import React, { useState } from "react";
import { Mail, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function SubscribeToUpdates({ isOpen, onClose }) {
  const [email, setEmail] = useState("");
  const handleSubscribe = () => {
    if (email.includes("@")) {
      alert(`Thank you! ${email} has been subscribed.`);
      setEmail("");
      onClose(); // Close the popup
    }
  };
  return (
    <>
      {/* Trigger Button — You can place this anywhere (e.g. in your changelog hero) */}
      {/* <button
                onClick={() => setIsOpen(true)}
                className="px-5 py-2.5 rounded-xl font-medium bg-white text-[#093A5B] hover:bg-[#F8FAFC] active:scale-[0.98] flex items-center gap-2 transition-all"
            >
                <Mail className="w-4 h-4" />
                Subscribe to updates
            </button> */}

      {/* POPUP MODAL */}
      {/* <AnimatePresence>
                {isOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={onClose}
                            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
                        />

                        <motion.div
                            initial={{ opacity: 0, scale: 0.9, y: 20 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            exit={{ opacity: 0, scale: 0.9, y: 20 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            className="fixed inset-0 z-50 flex items-center justify-center p-4"
                        >
                            <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden">
                                <button
                                    onClick={onClose}
                                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
                                >
                                    <X className="w-6 h-6" />
                                </button>

                                <div className="p-8 pt-12 text-center">
                                    <div className="w-16 h-16 bg-[#0EA5E9]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                        <Mail className="w-9 h-9 text-[#0EA5E9]" />
                                    </div>

                                    <h2 className="text-2xl font-bold text-[#093A5B] mb-3">
                                        Subscribe to updates
                                    </h2>

                                    <p className="text-gray-600 text-sm leading-relaxed mb-8">
                                        Get notified when we ship new features, improvements, and fixes.
                                        No spam, unsubscribe anytime.
                                    </p>

                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="you@company.com"
                                        className="w-full px-5 py-4 rounded-xl border border-gray-200 focus:border-[#0EA5E9] focus:outline-none
                                         text-gray-800 placeholder-gray-400 mb-4 transition"
                                        onKeyPress={(e) => e.key === 'Enter' && handleSubscribe()}
                                    />

                                    <div className="flex gap-3 justify-center">
                                        <button
                                            onClick={onClose}
                                            className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSubscribe}
                                            disabled={!email.includes('@')}
                                            className="px-8 py-3 rounded-xl bg-[#0EA5E9] text-white font-medium hover:bg-[#0d94d1] disabled:opacity-50 disabled:cursor-not-allowed transition shadow-lg"
                                        >
                                            Subscribe
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence> */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={onClose}
              className="ChangeLog_Backdrop_Class"
            />

            {/* Modal Wrapper */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="ChangeLog_Popup_Class"
            >
              <div className="ChangeLog_Popup_Box">
                <button onClick={onClose} className="ChangeLog_Close_Button">
                  <X className="ChangeLog_Close_Icon" />
                </button>

                <div className="ChangeLog_Popup_Content">
                  <div className="ChangeLog_Popup_Icon">
                    <Mail className="ChangeLog_Popup_IconSvg" />
                  </div>

                  <h2 className="ChangeLog_Popup_Title">
                    Subscribe to updates
                  </h2>

                  <p className="ChangeLog_Popup_Description">
                    Get notified when we ship new features, improvements, and
                    fixes. No spam, unsubscribe anytime.
                  </p>

                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    className="ChangeLog_Popup_Input"
                    onKeyPress={(e) => e.key === "Enter" && handleSubscribe()}
                  />

                  <div className="ChangeLog_Popup_Button_Group">
                    <button
                      onClick={onClose}
                      className="ChangeLog_Popup_Cancel_Button"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleSubscribe}
                      disabled={!email.includes("@")}
                      className="ChangeLog_Popup_Subscribe_Button"
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
